import { store } from '../store'
import http from '../api/api'
import config from '../api/constants'
import * as CryptoJS from 'crypto-js'
import { JSEncrypt } from 'jsencrypt'

const getAllAccountNumbers = async () => {
  try {
    const reqParams = {
      requestId: 'ACCOUNTDETAILS',
      accountType: 'S',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getPickUpBranches = async () => {
  try {
    const reqParams = {
      requestId: 'GETBRANCHDETAILS',
    }
    const response = await http.post(config.apiRoute.GET_BRANCH_DETAILS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const checkEligibility = async (accountNumber) => {
  try {
    const reqParams = {
      srcAccount: accountNumber,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.apiRoute.GET_CHEQUE_BOOK_ELIGIBILITY, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getAccountTermsAndConditions = async () => {
  try {
    const reqParams = {
      requestId: 'TERMS',
      module: 'CBR',
    }
    const response = await http.post(config.apiRoute.GET_TERMS_AND_CONDITIONS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const validateChequeBookRequest = async ({
  accountNumber,
  address,
  numberOfChequeBooks,
  numberOfLeaves,
  pickupBranchCode,
}) => {
  try {
    const reqParams = {
      srcAccount: accountNumber,
      address: address,
      noOfChequeBooks: numberOfChequeBooks,
      noOfLeaves: numberOfLeaves,
      brnCode: pickupBranchCode,
      requestId: 'CHEQUEBOOK',
      module: 'CHECK_BOOK',
      deliveryMode: 'B',
    }
    const response = await http.post(config.apiRoute.CHEQUE_BOOK_VERIFICATION, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const chequeBookRequest = async ({
  accountNumber,
  address,
  numberOfChequeBooks,
  numberOfLeaves,
  otp,
  pickupBranchCode,
  customerNo,
  accountName,
}) => {
  const reqParams = {
    srcAccount: accountNumber,
    deliveryAddress: address,
    noOfChequeBooks: numberOfChequeBooks,
    noOfLeaves: numberOfLeaves,
    srcAccBranch: pickupBranchCode,
    otp: otp,
    deliveryMode: 'B',
    requestId: 'CHEQUEBOOK',
    module: 'CHECK_BOOK',
    customerNo: customerNo,
    accountName: accountName,
  }
  try {
    const response = await http.post(config.apiRoute.CHEQUE_BOOK_CONFIRMATION, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyChequeStatus = async ({ accountNumber, chequeNumber, brnCode }) => {
  try {
    const reqParams = {
      srcAccount: accountNumber,
      chequeNo: chequeNumber,
      requestId: 'CHEQUESTATUS',
      brnCode: brnCode,
      module: 'CHECK_BOOK',
      amount: '',
    }
    const response = await http.post(config.apiRoute.CHEQUE_BOOK_STATUS_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const changeChequeStatus = async ({ accountNumber, chequeNumber, otp, brnCode }) => {
  try {
    const reqParams = {
      chequeNo: chequeNumber,
      srcAccount: accountNumber,
      otpNo: otp,
      requestId: 'CHEQUESTATUSCONFIRM',
      brnCode: brnCode,
      module: 'CHECK_BOOK',
      amount: '',
    }
    const response = await http.post(config.apiRoute.CHEQUE_BOOK_STATUS_CHANGE_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyStopChequePayment = async ({
  accountNumber,
  chequeEndNumber,
  chequeStartNumber,
  effectiveDate,
  reason,
  requestType,
  branchCode,
  remarks
}) => {
  try {
    const reqParams = {
      srcAccount: accountNumber,
      effectiveDate: effectiveDate,
      endChequeNumber: chequeEndNumber,
      startChequeNumber: chequeStartNumber,
      reason: reason,
      requestType: requestType,
      requestId: 'STOPCHEQUEBOOK',
      module: 'CHECK_BOOK',
      brnCode: branchCode,
      amount: '',
      remarks:remarks
    }
    const response = await http.post(config.apiRoute.STOP_CHEQUE_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const stopChequePayment = async ({
  accountNumber,
  chequeEndNumber,
  chequeStartNumber,
  effectiveDate,
  otp,
  reason,
  requestType,
  branchCode,
  remarks
}) => {
  try {
    const reqParams = {
      srcAccount: accountNumber,
      effectiveDate,
      endChequeNumber: chequeEndNumber,
      startChequeNumber: chequeStartNumber,
      otpNo: otp,
      reason,
      requestType,
      requestId: 'STOPCHECKBOOKCONFIRM',
      module: 'CHECK_BOOK',
      brnCode: branchCode,
      amount: '',
      remarks:remarks
    }
    const response = await http.post(config.apiRoute.CONFIRM_CHEQUE_STOP, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const createStandingInstruction = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'SIREQUEST',
      module: '',
    }
    const response = await http.post(config.apiRoute.CREATE_SI_REQUEST, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const getSiTerms = async () => {
  try {
    const reqParams = {
      requestId: 'TERMS',
      module: 'SI',
    }
    const response = await http.post(config.apiRoute.GET_TERMS_AND_CONDITIONS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const confirmCreateStandingInstruction = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      module: '',
      requestId: 'SIREQUESTCONFIRM',
    }
    const response = await http.post(config.apiRoute.CONFIRM_CREATE_SI_REQUEST, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getCardList = async ({ accountNumber }) => {
  try {
    const reqParams = {
      accountNo: accountNumber,
      requestId: 'CARDLIST',
    }
    const response = await http.post(config.apiRoute.GET_CARD_LIST, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getStandingInstructions = async () => {
  try {
    const reqParams = {
      requestId: 'GETSILIST',
    }
    const response = await http.post(config.apiRoute.GET_SI_LIST, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getCardAccounts = async ({ cardNumber }) => {
  try {
    const reqParams = {
      cardNumber,
      requestId: 'GETCARDACCOUNTS',
    }
    const response = await http.post(config.apiRoute.GET_CARD_ACCOUNTS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const blockDebitCardVerify = async (data) => {
  const { app } = store.getState()
  try {
    const reqParams = {
      ...data,
      branch: app.profile.branchCode,
      cardStatus: 'B',
      requestId: 'BLOCKDEBITCARD',
      module: 'DEBITCARD'
    }
    const response = await http.post(config.apiRoute.BLOCK_DEBIT_CARD_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const blockDebitCardConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      cardStatus: 'B',
      requestId: 'BLOCKDEBITCARD',
      module: 'DEBITCARD'
    }
    const response = await http.post(config.apiRoute.BLOCK_DEBIT_CARD_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyCardLoad = async ({
  amount,
  cardNumber,
  sourceAccount,
  sourceAccountBranch,
  sourceAccountCurrency,
}) => {
  try {
    const reqParams = {
      cardNumber,
      requestId: 'STMBVERIFY',
      srcAccount: sourceAccount,
      srcCurrency: sourceAccountCurrency,
      srcBranch: sourceAccountBranch,
      amount,
    }
    const response = await http.post(config.apiRoute.VERIFY_CARD_LOAD, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const confirmCardLoad = async ({
  accountId,
  amount,
  cardAccountCurrency,
  cardNumber,
  otp,
  randomKey,
  sourceAccount,
  sourceAccountBranch,
  sourceAccountCurrency,
}) => {
  try {
    const reqParams = {
      accountId,
      requestId: 'CARDLOADCONFIRM',
      cardAccountCurrency,
      cardNumber,
      amount,
      srcAccount: sourceAccount,
      srcCurrency: sourceAccountCurrency,
      srcBranch: sourceAccountBranch,
      otp,
      randomKey,
    }
    const response = await http.post(config.apiRoute.CONFIRM_CARD_LOAD, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const decryptAES = (uuid, value) => {
  var key = CryptoJS.enc.Utf8.parse(uuid)
  var iv = CryptoJS.enc.Utf8.parse(uuid)
  var decrypted = CryptoJS.AES.decrypt(value, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding,
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

const getEncryptedValues = async (publicKey, newPIN, cardNumber, uuid) => {
  const decryptedPublicKey = decryptAES(uuid, publicKey)
  const encryptedPIN = await encryptField(uuid, newPIN, decryptedPublicKey)
  const encryptedCardNumber = await encryptField(uuid, cardNumber, decryptedPublicKey)
  return {
    newPIN: encryptedPIN,
    cardNumber: encryptedCardNumber,
  }
}
const encryptRSA = async (publicKey, value) => {
  const RSA = new JSEncrypt()
  RSA.setPublicKey(publicKey)
  return RSA.encrypt(value).toString()
}
const encryptField = (uuid, value, decryptedPublicKey) => {
  const combinedText = `${uuid}:${value}:${Date.now()}`
  return encryptRSA(decryptedPublicKey, combinedText)
}

const changeCardPIN = async ({ cardNumber, expiryDate, newPin, oldPin, uuid }) => {
  const reqParams = {
    requestId: 'ENCRYPTEDPUBKEY',
    uuid,
  }
  const encryptionKey = await http.post(config.apiRoute.GET_ENCRYPTED_KEY, reqParams)
  const encryptedData = await getEncryptedValues(
    encryptionKey.data.publicKey,
    newPin,
    cardNumber,
    uuid,
  )
  try {
    const response = await http.post(config.apiRoute.CHANGE_CARD_PIN, {
      requestId: 'CHANGECARDPIN',
      cardNumber: encryptedData.cardNumber,
      newPin: encryptedData.newPIN,
      expiryDate,
      uuid,
      emvData: '',
      oldPin,
    })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getChequeBookStatus = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: 'CHEQUEBOOKSTATUS',
      requestId: 'CHEQUEBOOKSTATUS',
    }
    const response = await http.post(config.apiRoute.CHEQUE_BOOK_STATUS_ENQUIRY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getStopChequeReasonList = async () => {
  try {
    const reqParams = {
      requestId: 'STOPCHEQUEREASONLIST',
    }
    const response = await http.post(config.apiRoute.STOP_CHEQUE_REASON_LIST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}


const debitCardRequestVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'DEBITCARD_VERIFY',
    }
    const response = await http.post(config.apiRoute.DEBIT_CARD_REQUEST_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}


const debitCardRequestConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'DEBITCARD_CONFIRM',
    }
    const response = await http.post(config.apiRoute.DEBIT_CARD_REQUEST_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getCardDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
    }
    const response = await http.post(config.apiRoute.GET_CARD_DEATILS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const RequestService = {
  getAllAccountNumbers,
  getPickUpBranches,
  checkEligibility,
  getAccountTermsAndConditions,
  validateChequeBookRequest,
  chequeBookRequest,
  verifyChequeStatus,
  changeChequeStatus,
  verifyStopChequePayment,
  stopChequePayment,
  createStandingInstruction,
  getSiTerms,
  confirmCreateStandingInstruction,
  getCardList,
  getStandingInstructions,
  getCardAccounts,
  blockDebitCardVerify,
  blockDebitCardConfirm,
  verifyCardLoad,
  confirmCardLoad,
  changeCardPIN,
  getChequeBookStatus,
  getStopChequeReasonList,
  debitCardRequestVerify,
  debitCardRequestConfirm,
  getCardDetails
}

export default RequestService
